import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/** Asked before a multi-piece project is finished with a single workpiece:
 * confirming turns it into an ordinary single project, cancelling stays put. */
export default function SinglePieceConfirm({
  open,
  onOpenChange,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Are you sure this is a multi-piece project?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Only one piece is attached. You can submit it on its own as a single
            project — nothing you have filled in is lost — or go back and add
            the remaining piece.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Oops, I need another piece</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            No, it&apos;s single-piece
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
